// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'

import './theme/index.css'
import ElementUI from 'element-ui'
import common from '../static/js/common.js'

// 引入我的css文件
require("../static/css/style.css")

import router from './router'
import '../static/css/common.css'
import VueResource from 'vue-resource'
import $ from 'jquery'


Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueResource) 

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


function IEVersion() {
	var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
	var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
	var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
	var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
	if(isIE) {
	    var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
	    reIE.test(userAgent);
	    var fIEVersion = parseFloat(RegExp["$1"]);
	    if(fIEVersion == 7) {
	        return 7;
	    } else if(fIEVersion == 8) {
	        return 8;
	    } else if(fIEVersion == 9) {
	        return 9;
	    } else if(fIEVersion == 10) {
	        return 10;
	    } else {
	        return 6;//IE版本<=7
	    }   
	} else if(isEdge) {
	    return 'edge';//edge
	} else if(isIE11) {
	    return 11; //IE11  
	}else{
	    return -1;//不是ie浏览器
	}
}
if(typeof IEVersion() == 'number'){
	if(IEVersion()<=9&&IEVersion()>0){
		router.replace({path:'/tip'});
	}
}







// WEBPACK FOOTER //
// ./src/main.js